var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForecast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00037 1.2504C11.7281 1.25061 14.7504 4.2726 14.7504 8.0004C14.7502 11.728 11.728 14.7502 8.00037 14.7504C4.27257 14.7504 1.25058 11.7281 1.25037 8.0004C1.25037 4.27247 4.27244 1.2504 8.00037 1.2504ZM8.00037 2.7504C5.10087 2.7504 2.75037 5.1009 2.75037 8.0004C2.75058 10.8997 5.101 13.2504 8.00037 13.2504C10.8996 13.2502 13.2502 10.8996 13.2504 8.0004C13.2504 5.10103 10.8997 2.75061 8.00037 2.7504ZM10.6879 5.04044C10.8636 4.94281 11.0576 5.13617 10.9603 5.31192L9.49744 7.94376C9.13471 8.59661 8.59658 9.13474 7.94373 9.49747L5.31189 10.9604C5.13614 11.0576 4.94278 10.8636 5.04041 10.6879L6.50232 8.05606C6.86504 7.40326 7.40323 6.86507 8.05603 6.50235L10.6879 5.04044Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.9cb15e3a211bb0b372e1a008121c9d79.svg";
export { ForwardRef as ReactComponent };